export const mobileData = {
  id: 'mobile',
  title: 'Mobile Developer',
  icon: 'Smartphone',
  color: 'from-purple-500 to-pink-600',
  description: 'Recursos de desarrollo móvil, frameworks y herramientas',
  categories: [
    {
      name: 'Frameworks & Plataformas',
      icon: 'Code',
      resources: [
        {
          id: 'flutter-1',
          title: 'Flutter - Desarrollo Cross-Platform',
          type: 'Tutorial',
          description: 'Guía completa de Flutter para desarrollo móvil cross-platform, incluyendo widgets, state management y deployment.',
          tags: ['Flutter', 'Dart', 'Cross-Platform'],
          difficulty: 'Intermedio',
          estimatedTime: '3h',
          lastUpdated: '2024-01-15',
          author: 'Mobile Team',
          downloads: 198,
          rating: 4.8,
          content: {
            sections: [
              {
                title: 'Instalación y Configuración',
                content: 'Setup completo del entorno de desarrollo Flutter en diferentes sistemas operativos.',
                subsections: [
                  'Instalación de Flutter SDK',
                  'Configuración de variables de entorno',
                  'IDE setup (VS Code, Android Studio)',
                  'Flutter doctor',
                  'Configuración de emuladores'
                ]
              },
              {
                title: 'Widgets y Layouts',
                content: 'Sistema de widgets de Flutter y creación de layouts responsivos.',
                subsections: [
                  'Stateless vs Stateful widgets',
                  'Layout widgets (Row, Column, Stack)',
                  'Container y Box widgets',
                  'Responsive design',
                  'Custom widgets'
                ]
              },
              {
                title: 'State Management',
                content: 'Diferentes enfoques para gestión de estado en aplicaciones Flutter.',
                subsections: [
                  'setState básico',
                  'Provider pattern',
                  'Bloc pattern',
                  'Riverpod',
                  'GetX'
                ]
              },
              {
                title: 'Navegación',
                content: 'Sistema de navegación y routing en aplicaciones Flutter.',
                subsections: [
                  'Navigator 1.0',
                  'Navigator 2.0',
                  'Named routes',
                  'Deep linking',
                  'Navigation patterns'
                ]
              },
              {
                title: 'Integración con APIs',
                content: 'Consumo de APIs REST y manejo de datos en Flutter.',
                subsections: [
                  'HTTP requests con http package',
                  'JSON parsing',
                  'State management con APIs',
                  'Error handling',
                  'Loading states'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Flutter-Guia-Completa.pdf',
              type: 'application/pdf',
              size: 3072000
            },
            {
              name: 'ejemplos-flutter.zip',
              type: 'application/zip',
              size: 2048000
            }
          ],
          externalLinks: [
            {
              title: 'Flutter Documentation',
              description: 'Documentación oficial de Flutter',
              url: 'https://docs.flutter.dev/'
            }
          ]
        },
        {
          id: 'react-native-1',
          title: 'React Native - Performance',
          type: 'Guía',
          description: 'Optimización de performance en React Native, incluyendo profiling, memory management y optimización de bundle.',
          tags: ['React Native', 'Performance', 'JavaScript'],
          difficulty: 'Avanzado',
          estimatedTime: '2.5h',
          lastUpdated: '2024-01-12',
          author: 'Performance Team',
          downloads: 145,
          rating: 4.7,
          content: {
            sections: [
              {
                title: 'Bundle Optimization',
                content: 'Técnicas para reducir el tamaño del bundle y mejorar el tiempo de carga.',
                subsections: [
                  'Metro bundler configuration',
                  'Tree shaking',
                  'Code splitting',
                  'Asset optimization',
                  'Bundle analysis'
                ]
              },
              {
                title: 'Image Optimization',
                content: 'Optimización de imágenes para mejorar el performance y reducir el uso de memoria.',
                subsections: [
                  'Image formats',
                  'Compression techniques',
                  'Lazy loading',
                  'Caching strategies',
                  'Progressive loading'
                ]
              },
              {
                title: 'Memory Management',
                content: 'Estrategias para gestionar la memoria de manera eficiente en React Native.',
                subsections: [
                  'Memory leaks prevention',
                  'Image memory management',
                  'List virtualization',
                  'Component lifecycle',
                  'Memory profiling'
                ]
              },
              {
                title: 'Native Modules',
                content: 'Optimización de módulos nativos y bridge performance.',
                subsections: [
                  'Bridge optimization',
                  'Native module design',
                  'Batch operations',
                  'Async operations',
                  'Performance monitoring'
                ]
              },
              {
                title: 'Profiling Tools',
                content: 'Herramientas para profiling y análisis de performance en React Native.',
                subsections: [
                  'Flipper',
                  'React DevTools',
                  'Performance Monitor',
                  'Memory profiler',
                  'Network profiler'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'React Native Performance',
              description: 'Guía de performance de React Native',
              url: 'https://reactnative.dev/docs/performance'
            }
          ]
        }
      ]
    },
    {
      name: 'IDEs & Herramientas',
      icon: 'Wrench',
      resources: [
        {
          id: 'android-studio-1',
          title: 'Android Studio - Configuración Avanzada',
          type: 'Guía',
          description: 'Configuración y optimización de Android Studio para desarrollo móvil eficiente.',
          tags: ['Android Studio', 'IDE', 'Android'],
          difficulty: 'Intermedio',
          estimatedTime: '2h',
          lastUpdated: '2024-01-10',
          author: 'Android Team',
          downloads: 167,
          rating: 4.6,
          content: {
            sections: [
              {
                title: 'Configuración del Emulador',
                content: 'Setup y optimización de emuladores de Android para desarrollo.',
                subsections: [
                  'AVD Manager',
                  'Hardware acceleration',
                  'Emulator performance',
                  'Device profiles',
                  'Snapshot management'
                ]
              },
              {
                title: 'Gradle Optimization',
                content: 'Optimización de builds de Gradle para reducir tiempos de compilación.',
                subsections: [
                  'Gradle daemon',
                  'Parallel execution',
                  'Build cache',
                  'Dependency management',
                  'Build variants'
                ]
              },
              {
                title: 'Debugging Tools',
                content: 'Herramientas avanzadas de debugging en Android Studio.',
                subsections: [
                  'Debugger configuration',
                  'Breakpoints',
                  'Variable inspection',
                  'Call stack analysis',
                  'Conditional breakpoints'
                ]
              },
              {
                title: 'Profiling',
                content: 'Herramientas de profiling para análisis de performance.',
                subsections: [
                  'CPU profiler',
                  'Memory profiler',
                  'Network profiler',
                  'Energy profiler',
                  'Profiling reports'
                ]
              },
              {
                title: 'Plugins Útiles',
                content: 'Plugins esenciales para mejorar la productividad en Android Studio.',
                subsections: [
                  'Key Promoter X',
                  'Rainbow Brackets',
                  'String Manipulation',
                  'Android WiFi ADB',
                  'Material Theme UI'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Android-Studio-Guia.pdf',
              type: 'application/pdf',
              size: 2560000
            }
          ]
        },
        {
          id: 'xcode-1',
          title: 'Xcode - Desarrollo iOS',
          type: 'Tutorial',
          description: 'Uso avanzado de Xcode para desarrollo iOS, incluyendo Interface Builder y herramientas de debugging.',
          tags: ['Xcode', 'IDE', 'iOS'],
          difficulty: 'Intermedio',
          estimatedTime: '2h',
          lastUpdated: '2024-01-18',
          author: 'iOS Team',
          downloads: 134,
          rating: 4.8,
          content: {
            sections: [
              {
                title: 'Interface Builder',
                content: 'Uso de Interface Builder para crear interfaces de usuario visualmente.',
                subsections: [
                  'Storyboard basics',
                  'Auto Layout constraints',
                  'Size classes',
                  'Interface Builder tips',
                  'Custom views'
                ]
              },
              {
                title: 'Storyboards y Constraints',
                content: 'Creación de layouts responsivos con Auto Layout y constraints.',
                subsections: [
                  'Constraint types',
                  'Priority system',
                  'Safe areas',
                  'Layout margins',
                  'Constraint conflicts'
                ]
              },
              {
                title: 'Debugging',
                content: 'Técnicas de debugging avanzadas en Xcode.',
                subsections: [
                  'LLDB debugger',
                  'Breakpoint management',
                  'Variable inspection',
                  'Call stack analysis',
                  'Debug console'
                ]
              },
              {
                title: 'Instruments',
                content: 'Uso de Instruments para profiling y análisis de performance.',
                subsections: [
                  'Time Profiler',
                  'Allocations',
                  'Leaks',
                  'Core Animation',
                  'Network'
                ]
              },
              {
                title: 'Simulator',
                content: 'Configuración y uso del iOS Simulator para testing.',
                subsections: [
                  'Device configuration',
                  'Simulator features',
                  'Location simulation',
                  'Hardware simulation',
                  'Simulator tips'
                ]
              }
            ]
          }
        }
      ]
    },
    {
      name: 'Testing & Deploy',
      icon: 'Shield',
      resources: [
        {
          id: 'testing-1',
          title: 'Mobile Testing - Estrategias',
          type: 'Guía',
          description: 'Estrategias comprehensivas de testing para aplicaciones móviles, incluyendo diferentes tipos de testing.',
          tags: ['Testing', 'Mobile', 'QA'],
          difficulty: 'Intermedio',
          estimatedTime: '2.5h',
          lastUpdated: '2024-01-08',
          author: 'QA Team',
          downloads: 189,
          rating: 4.7,
          content: {
            sections: [
              {
                title: 'Unit Testing',
                content: 'Testing de unidades individuales de código en aplicaciones móviles.',
                subsections: [
                  'JUnit para Android',
                  'XCTest para iOS',
                  'Testing frameworks',
                  'Mock objects',
                  'Test coverage'
                ]
              },
              {
                title: 'Integration Testing',
                content: 'Testing de la integración entre diferentes componentes de la aplicación.',
                subsections: [
                  'Component integration',
                  'API integration',
                  'Database testing',
                  'Service testing',
                  'Error handling'
                ]
              },
              {
                title: 'UI Testing',
                content: 'Testing de la interfaz de usuario y interacciones del usuario.',
                subsections: [
                  'Espresso para Android',
                  'XCUITest para iOS',
                  'UI automation',
                  'Gesture testing',
                  'Accessibility testing'
                ]
              },
              {
                title: 'Device Testing',
                content: 'Testing en dispositivos físicos y diferentes configuraciones.',
                subsections: [
                  'Device fragmentation',
                  'OS version testing',
                  'Screen size testing',
                  'Hardware testing',
                  'Real device testing'
                ]
              },
              {
                title: 'Automation',
                content: 'Automatización de testing para CI/CD y testing continuo.',
                subsections: [
                  'CI/CD integration',
                  'Test automation',
                  'Parallel execution',
                  'Test reporting',
                  'Failure analysis'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'Mobile Testing Best Practices',
              description: 'Mejores prácticas en testing móvil',
              url: 'https://www.applitools.com/blog/mobile-testing-best-practices/'
            }
          ]
        },
        {
          id: 'deploy-1',
          title: 'TestFlight - Deploy iOS',
          type: 'Tutorial',
          description: 'Deploy de aplicaciones iOS usando TestFlight para testing beta y distribución interna.',
          tags: ['TestFlight', 'iOS', 'Deploy'],
          difficulty: 'Intermedio',
          estimatedTime: '1.5h',
          lastUpdated: '2024-01-16',
          author: 'DevOps Team',
          downloads: 98,
          rating: 4.6,
          content: {
            sections: [
              {
                title: 'Configuración de App Store Connect',
                content: 'Setup inicial de App Store Connect para distribución de apps.',
                subsections: [
                  'Account setup',
                  'App configuration',
                  'Bundle ID setup',
                  'Provisioning profiles',
                  'Certificates'
                ]
              },
              {
                title: 'Upload de Builds',
                content: 'Proceso de upload de builds a TestFlight.',
                subsections: [
                  'Archive process',
                  'Upload to App Store Connect',
                  'Build processing',
                  'TestFlight activation',
                  'Build management'
                ]
              },
              {
                title: 'Configuración de Testers',
                content: 'Configuración y gestión de testers en TestFlight.',
                subsections: [
                  'Internal testers',
                  'External testers',
                  'Tester groups',
                  'Feedback collection',
                  'Tester management'
                ]
              },
              {
                title: 'Feedback y Crash Reports',
                content: 'Recolección y análisis de feedback y crash reports.',
                subsections: [
                  'Feedback collection',
                  'Crash reporting',
                  'Analytics integration',
                  'Bug tracking',
                  'User feedback'
                ]
              },
              {
                title: 'Beta Testing',
                description: 'Proceso de beta testing y iteración basada en feedback.',
                subsections: [
                  'Beta testing workflow',
                  'Version management',
                  'Release notes',
                  'Testing cycles',
                  'Production release'
                ]
              }
            ]
          }
        },
        {
          id: 'deploy-2',
          title: 'Google Play Console - Deploy Android',
          type: 'Guía',
          description: 'Deploy de aplicaciones Android en Google Play Store, incluyendo configuración y gestión de releases.',
          tags: ['Google Play', 'Android', 'Deploy'],
          difficulty: 'Intermedio',
          estimatedTime: '2h',
          lastUpdated: '2024-01-14',
          author: 'DevOps Team',
          downloads: 123,
          rating: 4.5,
          content: {
            sections: [
              {
                title: 'Configuración de Cuenta',
                content: 'Setup inicial de Google Play Console y configuración de la cuenta de desarrollador.',
                subsections: [
                  'Developer account setup',
                  'Payment information',
                  'Account verification',
                  'Developer profile',
                  'Account settings'
                ]
              },
              {
                title: 'Upload de APK/AAB',
                content: 'Proceso de upload de archivos APK o Android App Bundle.',
                subsections: [
                  'APK vs AAB',
                  'Build configuration',
                  'Upload process',
                  'Version management',
                  'Release tracks'
                ]
              },
              {
                title: 'Store Listing',
                content: 'Configuración de la ficha de la aplicación en Google Play.',
                subsections: [
                  'App description',
                  'Screenshots',
                  'Feature graphic',
                  'App category',
                  'Content rating'
                ]
              },
              {
                title: 'Release Management',
                content: 'Gestión de releases y versiones de la aplicación.',
                subsections: [
                  'Release tracks',
                  'Staged rollouts',
                  'Version management',
                  'Release notes',
                  'Rollback procedures'
                ]
              },
              {
                title: 'Analytics',
                content: 'Análisis de métricas y performance de la aplicación.',
                subsections: [
                  'Install analytics',
                  'User engagement',
                  'Crash reporting',
                  'Performance metrics',
                  'Revenue analytics'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Google-Play-Deploy-Guide.pdf',
              type: 'application/pdf',
              size: 2048000
            }
          ]
        }
      ]
    },
    {
      name: 'UI/UX & Diseño',
      icon: 'Palette',
      resources: [
        {
          id: 'ui-1',
          title: 'Material Design - Android',
          type: 'Guía',
          description: 'Implementación de Material Design en aplicaciones Android, incluyendo componentes y theming.',
          tags: ['Material Design', 'Android', 'UI/UX'],
          difficulty: 'Intermedio',
          estimatedTime: '2h',
          lastUpdated: '2024-01-11',
          author: 'Design Team',
          downloads: 156,
          rating: 4.8,
          content: {
            sections: [
              {
                title: 'Componentes Material',
                content: 'Uso de componentes Material Design en aplicaciones Android.',
                subsections: [
                  'Material Components',
                  'Button components',
                  'Card components',
                  'Navigation components',
                  'Form components'
                ]
              },
              {
                title: 'Theming',
                content: 'Sistema de theming y personalización de Material Design.',
                subsections: [
                  'Color system',
                  'Typography',
                  'Shape system',
                  'Dark theme',
                  'Custom themes'
                ]
              },
              {
                title: 'Animaciones',
                content: 'Implementación de animaciones Material Design.',
                subsections: [
                  'Motion system',
                  'Transition animations',
                  'Ripple effects',
                  'Shared element transitions',
                  'Custom animations'
                ]
              },
              {
                title: 'Responsive Design',
                content: 'Diseño responsivo y adaptativo con Material Design.',
                subsections: [
                  'Breakpoint system',
                  'Grid system',
                  'Adaptive layouts',
                  'Screen size handling',
                  'Orientation changes'
                ]
              },
              {
                title: 'Accessibility',
                content: 'Implementación de accesibilidad en Material Design.',
                subsections: [
                  'Content descriptions',
                  'Touch targets',
                  'Color contrast',
                  'Screen readers',
                  'Accessibility testing'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'Material Design Guidelines',
              description: 'Guía oficial de Material Design',
              url: 'https://material.io/design'
            }
          ]
        },
        {
          id: 'ui-2',
          title: 'Human Interface Guidelines - iOS',
          type: 'Documentación',
          description: 'Guía de Human Interface Guidelines para desarrollo de aplicaciones iOS con diseño nativo.',
          tags: ['HIG', 'iOS', 'UI/UX'],
          difficulty: 'Intermedio',
          estimatedTime: '1.5h',
          lastUpdated: '2024-01-19',
          author: 'Design Team',
          downloads: 134,
          rating: 4.7,
          content: {
            sections: [
              {
                title: 'Principios de Diseño',
                content: 'Principios fundamentales del diseño de interfaces humanas en iOS.',
                subsections: [
                  'Clarity',
                  'Deference',
                  'Depth',
                  'Consistency',
                  'Accessibility'
                ]
              },
              {
                title: 'Componentes iOS',
                content: 'Componentes nativos de iOS y su implementación.',
                subsections: [
                  'UIKit components',
                  'SwiftUI components',
                  'Custom components',
                  'Component behavior',
                  'Component guidelines'
                ]
              },
              {
                title: 'Layout y Spacing',
                content: 'Sistema de layout y espaciado en aplicaciones iOS.',
                subsections: [
                  'Auto Layout',
                  'Safe areas',
                  'Spacing system',
                  'Grid system',
                  'Layout guidelines'
                ]
              },
              {
                title: 'Typography',
                content: 'Sistema tipográfico de iOS y mejores prácticas.',
                subsections: [
                  'System fonts',
                  'Font sizes',
                  'Font weights',
                  'Text hierarchy',
                  'Readability'
                ]
              },
              {
                title: 'Color y Contrast',
                content: 'Sistema de colores y contraste en aplicaciones iOS.',
                subsections: [
                  'System colors',
                  'Color contrast',
                  'Dark mode',
                  'Color accessibility',
                  'Brand colors'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'Human Interface Guidelines',
              description: 'Guía oficial de HIG de Apple',
              url: 'https://developer.apple.com/design/human-interface-guidelines/'
            }
          ]
        }
      ]
    },
    {
      name: 'Performance & Optimización',
      icon: 'Zap',
      resources: [
        {
          id: 'perf-1',
          title: 'Mobile Performance - Métricas',
          type: 'Guía',
          description: 'Métricas y herramientas de performance móvil para optimización de aplicaciones.',
          tags: ['Performance', 'Mobile', 'Optimización'],
          difficulty: 'Avanzado',
          estimatedTime: '2.5h',
          lastUpdated: '2024-01-07',
          author: 'Performance Team',
          downloads: 89,
          rating: 4.9,
          content: {
            sections: [
              {
                title: 'Core Web Vitals',
                content: 'Métricas fundamentales de performance web aplicadas a aplicaciones móviles.',
                subsections: [
                  'Largest Contentful Paint',
                  'First Input Delay',
                  'Cumulative Layout Shift',
                  'Performance budgets',
                  'Measurement tools'
                ]
              },
              {
                title: 'App Launch Time',
                content: 'Optimización del tiempo de lanzamiento de aplicaciones móviles.',
                subsections: [
                  'Cold start',
                  'Warm start',
                  'Hot start',
                  'Launch optimization',
                  'Background processes'
                ]
              },
              {
                title: 'Memory Usage',
                content: 'Gestión eficiente de memoria en aplicaciones móviles.',
                subsections: [
                  'Memory profiling',
                  'Memory leaks',
                  'Memory optimization',
                  'Garbage collection',
                  'Memory pressure'
                ]
              },
              {
                title: 'Battery Optimization',
                content: 'Optimización del consumo de batería en aplicaciones móviles.',
                subsections: [
                  'Background processing',
                  'Location services',
                  'Network requests',
                  'CPU usage',
                  'Battery profiling'
                ]
              },
              {
                title: 'Network Performance',
                content: 'Optimización del rendimiento de red en aplicaciones móviles.',
                subsections: [
                  'Request optimization',
                  'Caching strategies',
                  'Image optimization',
                  'API optimization',
                  'Network monitoring'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Mobile-Performance-Guide.pdf',
              type: 'application/pdf',
              size: 3072000
            }
          ]
        },
        {
          id: 'perf-2',
          title: 'Flutter Performance - Profiling',
          type: 'Tutorial',
          description: 'Profiling y optimización de performance en aplicaciones Flutter.',
          tags: ['Flutter', 'Performance', 'Profiling'],
          difficulty: 'Avanzado',
          estimatedTime: '2h',
          lastUpdated: '2024-01-13',
          author: 'Flutter Team',
          downloads: 76,
          rating: 4.6,
          content: {
            sections: [
              {
                title: 'Flutter Inspector',
                content: 'Uso de Flutter Inspector para análisis de widgets y debugging.',
                subsections: [
                  'Widget tree inspection',
                  'Render tree analysis',
                  'Performance overlay',
                  'Debugging tools',
                  'Inspector features'
                ]
              },
              {
                title: 'Performance Overlay',
                content: 'Uso del overlay de performance para monitoreo en tiempo real.',
                subsections: [
                  'Frame rate monitoring',
                  'Performance metrics',
                  'Real-time analysis',
                  'Performance debugging',
                  'Overlay configuration'
                ]
              },
              {
                title: 'Memory Profiling',
                content: 'Análisis de uso de memoria en aplicaciones Flutter.',
                subsections: [
                  'Memory allocation',
                  'Memory leaks',
                  'Garbage collection',
                  'Memory optimization',
                  'Profiling tools'
                ]
              },
              {
                title: 'Widget Rebuilds',
                content: 'Optimización de rebuilds de widgets para mejorar performance.',
                subsections: [
                  'Rebuild analysis',
                  'Optimization techniques',
                  'State management',
                  'Widget lifecycle',
                  'Performance tips'
                ]
              },
              {
                title: 'Optimization Tips',
                content: 'Consejos prácticos para optimizar performance en Flutter.',
                subsections: [
                  'Code optimization',
                  'Asset optimization',
                  'Build optimization',
                  'Runtime optimization',
                  'Best practices'
                ]
              }
            ]
          }
        }
      ]
    }
  ]
};
